var map = {
	"./Lora-Bold.ttf": 70295,
	"./Lora-Bold.woff": 70405,
	"./Lora-Bold.woff2": 2877,
	"./Lora-Regular.ttf": 36126,
	"./Lora-Regular.woff": 22334,
	"./Lora-Regular.woff2": 7672,
	"./Poppins-Bold.ttf": 84714,
	"./Poppins-Bold.woff": 3194,
	"./Poppins-Bold.woff2": 37484,
	"./Poppins-Regular.ttf": 87625,
	"./Poppins-Regular.woff": 61903,
	"./Poppins-Regular.woff2": 84415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51549;